import Card from '@material-ui/core/Card'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { fade } from '@material-ui/core/styles/colorManipulator'
import * as React from 'react'

import BoxRow from '../atom/BoxRow'
import Typography from '../base/Typography'

export type LeaveQuotaCardProps = {
  type?: 'annual' | 'medical' | 'nonpaid' | 'hospital'
  accrued: number
  taken: number
  remaining: number
  customTitle?: string
  isHideAccuredLabel?: boolean
  isHideTakenLabel?: boolean
  isHideRemainingdLabel?: boolean
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      width: theme.spacing(30),
      maxWidth: '100%',
      borderRadius: 8,
      padding: theme.spacing(2),
      background: fade(theme.palette.primary.main, 0.03)
    },
    cardContentLabel: {
      color: fade(theme.palette.primary.main, 0.7)
    },
    cardContentNumber: {
      color: theme.palette.primary.main
    }
  })
)

const LeaveQuotaCard: React.FC<LeaveQuotaCardProps> = (props) => {
  const {
    type = 'annual',
    accrued = 0,
    taken = 0,
    remaining = 0,
    customTitle,
    isHideAccuredLabel,
    isHideRemainingdLabel,
    isHideTakenLabel
  } = props
  let title
  switch (type) {
    case 'medical':
      title = 'Medical Leave (in hours)'
      break
    case 'nonpaid':
      title = 'Non Paid Leave (in hours)'
      break
    case 'hospital':
      title = 'Hospital Leave (in hours)'
      break
    default:
      title = 'Annual Leave (in hours)'
  }
  const classes = useStyles()
  return (
    <Card elevation={0} classes={{ root: classes.card }}>
      {customTitle ? (
        <Typography bodyVariants="smBold" children={customTitle} />
      ) : (
        <Typography bodyVariants="smBold" children={title} />
      )}
      <BoxRow gap={0.5} mt={1}>
        {!isHideAccuredLabel && (
          <BoxRow direction="column">
            <Typography
              className={classes.cardContentLabel}
              bodyVariants="xxsMedium"
              children="Accrued"
            />
            <Typography
              className={classes.cardContentNumber}
              variant="h5"
              children={accrued}
            />
          </BoxRow>
        )}
        {!isHideTakenLabel && (
          <BoxRow direction="column">
            <Typography
              className={classes.cardContentLabel}
              bodyVariants="xxsMedium"
              children="Taken"
            />
            <Typography
              className={classes.cardContentNumber}
              variant="h5"
              children={taken}
            />
          </BoxRow>
        )}
        {!isHideRemainingdLabel && (
          <BoxRow direction="column">
            <Typography
              className={classes.cardContentLabel}
              bodyVariants="xxsMedium"
              children="Remaining"
            />
            <Typography
              className={classes.cardContentNumber}
              variant="h5"
              children={remaining}
            />
          </BoxRow>
        )}
      </BoxRow>
    </Card>
  )
}

export default LeaveQuotaCard
